const Oidc = require('oidc-client');

Oidc.Log.logger = console;

let UserManager;

try {
  UserManager = require('oidc-client').UserManager;
} catch (a) {
  throw new Error("Could not find dependency: 'oidc-client'.");
}

export default function createUserManager(config) {
  let managerConfig = config;
  if (config.user_endpoint) {
    managerConfig = Object.assign({}, config, {
      metadata: {
        issuer: config.authority,
        authorization_endpoint: `${config.authority}/authorize`,
        userinfo_endpoint: config.user_endpoint,
        end_session_endpoint: '',
        jwks_uri: '',
      },
    });
  } else {
    managerConfig = Object.assign({}, config, {
      loadUserInfo: false,
      // includeIdTokenInSilentRenew: false,
    });
  }
  return new UserManager(managerConfig);
}



// WEBPACK FOOTER //
// ./src/app/helpers/createUserManager.js